<template>
  <div>
    <div
      class="row q-py-xl justify-center items-center full-height"
      v-if="loading"
    >
      <SAISpinner />
    </div>
    <div v-if="!loading">
      <BudgetProgress
        class="q-pb-lg bdr-b-grey-4"
        :budget="budget"
        :icon="budgetIcon"
        :label="budgetLabel"
      />
      <QInfiniteScroll
        @load="(index, done) => $emit('load:transactions', { index, done })"
        :offset="300"
        ref="infiniteScroll"
      >
        <BudgetTransactionGroup
          v-for="(group, index) in transactionGroups"
          :key="index"
          :group-date="group.groupDate"
          :total-balance="group.totalBalance"
          :icon="budgetIcon"
          :transactions="group.transactions"
        />
      </QInfiniteScroll>
      <div class="row justify-center q-mt-lg" v-if="transactionsLoading">
        <SAISpinner />
      </div>
      <div v-if="hasNoTransactions">
        <p class="text-weight-medium text-center q-mt-lg">
          No Transactions found
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { SAISpinner } from 'ecx.saigon.ui.common';
import { QInfiniteScroll } from 'quasar';

export default {
  name: 'BudgetDetail',
  props: {
    budget: {
      type: Object,
      default: () => ({})
    },
    loading: Boolean,
    budgetIcon: String,
    budgetLabel: String,
    hasNoTransactions: Boolean,
    transactionsLoading: Boolean,
    transactionGroups: {
      type: Array,
      default: () => []
    }
  },
  components: {
    QInfiniteScroll,
    SAISpinner,
    BudgetTransactionGroup: () =>
      import('../../organism/budget-transaction-group'),
    BudgetProgress: () => import('../../molecule/budget-progress')
  }
};
</script>
